<div class="on-demand-training-main">
  <div
    fxLayout="column"
    class="on-demand-training-rectangle"
    fxLayout.md="row"
    fxLayoutGap="20px"
  >
    <div fxFlex.lt-md="100" fxFlex="100" class="on-demand-training-wrapper">
      <h5
        class="on-demand-training-b"
        data-test-id="onDemandTrainingHeader"
        attr.aria-label="{{ 'broker.onDemandTraining.header' | translate }}"
      >
        {{ 'broker.onDemandTraining.header' | translate }}
      </h5>

      <div class="main-section">
        <div
          class="on-demand-training-content"
          data-test-id="onDemandTrainingContent"
          attr.aria-label="{{ 'broker.onDemandTraining.content' | translate }}"
        >
          <span>{{ 'broker.onDemandTraining.content' | translate }}</span>
          <br />
          <br />
          <div class="course-catalog">
            <ul>
              <li>
                <span class="right-section-body">{{
                  'broker.onDemandTraining.listItem1' | translate
                }}</span>
              </li>
              <li>
                <span class="right-section-body">{{
                  'broker.onDemandTraining.listItem2' | translate
                }}</span>
              </li>
              <li>
                <span>{{
                  'broker.onDemandTraining.listItem3' | translate
                }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="button">
          <button
            mat-raised-button
            cg-mat-btn-type="primary"
            [disabled]="isImpersonatorFlag"
            class="explore-content"
            data-test-id="explore-content-btn"
            (click)="getOnDemandExploreContent()"
          >
            {{ 'broker.onDemandTraining.exploreButton' | translate
            }}<span style="margin-left: 10px">
              <cigna-icon
                type="external-link"
                class="cg-mat-icon-link-right cg-color-digital-blue setMargin"
              ></cigna-icon
            ></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
